export default __webpack_public_path__ + "static/media/type-slider.f3532e9d.svg";